export type ExportDataField = {
    fieldName: string,
    value: any
}

export type ExportDataRow = ExportDataField[];

export type ExportData = ExportDataRow[];

export enum ExportFormat {
    PDF = "PDF",
    Excel = "Excel"
}

export type ExportSimpleObject = {
    name?: string,
    value?: string,
    id?: string,
    displayText?: string
}

export const sampleJSON = `[{"color":"black","category":"hue","type":"primary","code":"#000"},{"color":"white","category":"hue","type":"primary","code":"#FFF"},{"color":"red","category":"hue","type":"primary","code":"#FF0"},{"color":"blue","category":"hue","type":"primary","code":"#00F"},{"color":"yellow","category":"hue","type":"primary","code":"#FF0"},{"color":"green","category":"hue","type":"secondary","code":"#0F0"}]`;

